const navDropdownItems = document.querySelectorAll(
  ".nav__item"
);
const hiddenMenuNavigation = document.querySelectorAll('.back-menu-navigation');
const menuNavigation = document.querySelectorAll(".menu-navigation-item");
navDropdownItems.forEach((item) => {
  if ($( window ).width() >= 1200) {
    item.addEventListener("mouseover", () => {
      menuNavigation.forEach((value) => {
        if (item.title == value.title) {
          value.toggleAttribute("hidden", false);
        } else {
          value.toggleAttribute("hidden", true);
        }
      });
    });
    item.addEventListener("mouseout", () => {
      menuNavigation.forEach((value) => {
        value.toggleAttribute("hidden", true);
      });
    });
  }
  item.addEventListener('click', () => {
    menuNavigation.forEach((value) => {
      if (item.title == value.title) {
        value.toggleAttribute("hidden", false);
      } else {
        value.toggleAttribute("hidden", true);
      }
      value.style.top = `0px`;
    });
  });
});

hiddenMenuNavigation.forEach((item) => {
  item.addEventListener('click', () => {
    menuNavigation.forEach((value) => {
      value.toggleAttribute("hidden", true);
    });
  });
})

